import { useQuery } from 'react-query'
import { useChuckClientContext, useAPI } from '@gopeerproject/chuck'
import { useClassroomEnv } from '@components/ClassroomEnv'

export const useClassroomQuery = (options) => {
  const { get } = useAPI()
  const { client } = useChuckClientContext()
  const { id } = useClassroomEnv()

  return useQuery(
    ['classrooms', id],
    () => get({ url: `/classrooms/${id}` }).then((res) => res.data),
    {
      onError: (err) => {
        client.captureException(err)
      },
      refetchOnWindowFocus: false,
      refetchOnmount: false,
      refetchOnReconnect: false,
      retry: false,
      staleTime: Infinity,
      ...options
    }
  )
}
